<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Documento</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <document-form :generic="isGeneric" @save="saveDocument"></document-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import DocumentForm from './Forms/DocumentForm';
import swal from 'sweetalert2';

export default {
  name: 'DocumentsCreate',
  components: {
    RouteBreadCrumb,
    DocumentForm,
  },

  data() {
    return {
      id: null,
      type: null,
      isGeneric: false,
    };
  },

  created() {
    this.id = this.$route.params.id || null;
    this.type = this.$route.params.type || null;

    this.isGeneric = this.id === null || this.type === null;
  },

  methods: {
    saveDocument(document) {
      const documentableData = {
        documentableId: this.isGeneric ? document.entity.id : this.$route.params.id,
        documentableType: this.isGeneric ? document.entityType.value : this.$route.params.type,
      };

      const payload = Object.assign(document, documentableData);
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      this.$services
        .resource('documents')
        .create(payload, headers)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'El documento fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'DocumentsList' }));
        });
    },
  },
};
</script>
